import { currentIntlLocale } from '@/app/i18n'
import { looksLikeCurrencyCode } from '@/shared/lib/currencies'
import { formatMoneyValue } from '@/shared/lib/money'

/**
 * Xom sonni (minor birlik) `unit`ga qarab ko'rsatadi: `unit` ISO 4217
 * kodi bo'lsa PUL sifatida (`formatMoneyValue`), aks holda RAQAM +
 * BIRLIK sifatida — ledger faqat pulni emas, boshqa resurslarni ham
 * (masalan trafik kvotasini, `BYTE`) hisoblaydi.
 *
 * ⚠️ SHAKL bo'yicha, RO'YXAT bo'yicha emas.
 *
 * Ilgari bu yerda `CURRENCY_CODES.includes(code)` turardi. U ro'yxat —
 * Sozlamalar sahifasidagi TANLOV uchun qisqartirilgan to'plam (~80 kod),
 * ISO 4217 ning to'liq ro'yxati emas. Ya'ni undan tashqaridagi valyuta
 * (masalan MZN, BOB) `else` shoxiga tushib, ekranda XOM MINOR son bo'lib
 * chiqardi: 2 500 000 — aslida 25 000. Xato jimgina, chunki son o'ziga
 * o'xshab ko'rinadi, faqat 100 barobar katta.
 *
 * `currencyExponent` esa ro'yxatda yo'q kodga 2 beradi (ISO'dagi eng keng
 * tarqalgan holat), ya'ni to'g'ri javob standart yo'lda keladi. `BYTE` bu
 * yerga tushmaydi — u uch harfli emas.
 *
 * ⚠️ BITTA JOYDA: hisoblar jadvali, ko'chirma va tranzaksiya oynasi —
 * uchalasi ham shu funksiyani chaqiradi. Nusxalansa, bittasida shakl
 * tekshiruvi eskirib qolardi va aynan o'sha ekranda pul 100 barobar
 * katta ko'rinardi.
 */
export function formatLedgerAmount(amount: number, unit: string): string {
  const code = unit.trim().toUpperCase()
  if (looksLikeCurrencyCode(code)) return formatMoneyValue({ amount, currency: code })
  return `${amount.toLocaleString(currentIntlLocale())} ${unit}`
}
